import { Component, Prop, Vue } from 'vue-property-decorator';
/**
 * Shows either a list of selectable buttons or the selected one with a button to change the selection.
 *
 * TODO Consider using this UI for checkout donations, and gift-card/donation events (<AddOneToCart>).
 * @see https://tixtrackteam.slack.com/archives/CN2J3BTK7/p1718299044161009
 *
 * The Vue v2.5 syntax for slots was deprecated in v2.6 and removed in a later version.
 * @see https://v2.vuejs.org/v2/guide/components-slots#Scoped-Slots-with-the-slot-scope-Attribute
 */
@Component({ name: 'SelectableButtons' })
export default class default_1 extends Vue {
    @Prop({ required: true })
    value;
    @Prop({ required: true })
    buttons;
    @Prop({ default: false })
    showChangeButton;
    @Prop()
    selectedClass;
    // Selecting/deselecting swaps the list and the selected view in the DOM, destroying the focused element. Browsers
    // recover focus on Tab, but screen-reader virtual cursors do not and fall back to unrelated page elements.
    onSelect(button) {
        // Don't allow selection of disabled items
        if (button.disabled) {
            return;
        }
        this.$emit('input', button.item);
        this.$nextTick(() => {
            const changeButton = this.$refs.changeButton;
            changeButton?.focus();
        });
    }
    onDeselect() {
        this.$emit('input', undefined);
        this.$nextTick(() => {
            const listButtons = this.$refs.listButton ?? [];
            listButtons[0]?.focus();
        });
    }
}
